import React from 'react';
import { grey } from '@mui/material/colors';
import { Box, Stack, Typography } from '@mui/material';

export const GroupHeader = ({ label, count }: { label: string; count: number }) => (
  <Stack direction="row" gap="0.5rem" alignItems="center">
    <Typography variant="subtitle2" component="span" fontWeight={600}>
      {label}
    </Typography>

    <Box
      sx={{
        display: 'flex',
        minWidth: '1.25rem',
        height: '1.25rem',
        padding: '0 0.375rem',
        alignItems: 'center',
        borderRadius: '0.625rem',
        justifyContent: 'center',
        backgroundColor: grey[300],
      }}
    >
      <Typography variant="caption" fontWeight={600}>
        {count}
      </Typography>
    </Box>
  </Stack>
);
